import { Typography } from '@mui/material';
import { FunctionComponent } from 'react';

export const PageTitle: FunctionComponent<{ title: string }> = ({ title }) => {
  return (
    <Typography variant='h4' sx={{color: 'text.primary' }}> {title} </Typography>
  )
}